import { RemoteProfileGetById } from 'data/usecases';
import { makeApiUrlProfile } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteProfileGetById = (): RemoteProfileGetById => {
  return new RemoteProfileGetById(makeApiUrlProfile(), makeAxiosHttpClient());
};
